import { LayoutHOC } from 'base/ui/layout/layout';
import { addSurvey } from './addSurvey';

export const createAddSurveyPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(addSurvey());
};
